module.exports = __webpack_public_path__ + "staticVue/img/avatar.61151ed8.png";